import _extends from "@swc/helpers/src/_extends.mjs";
// DS: Indicators 1.7.18
import React from 'react';
import IconWrap from '../../IconWrap';
const Rarible = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#FEDA03"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16.5604 11.9122C17.3164 11.7157 17.989 11.1503 17.989 10.0133C17.989 8.12051 16.3819 7.67999 14.3224 7.67999H6.12V16.2038H9.57234V13.311H13.6676C14.2985 13.311 14.6676 13.561 14.6676 14.18V16.2038H18.12V14.0729C18.12 12.9122 17.4652 12.18 16.5604 11.9122ZM13.7271 11.0134H9.57234V10.18H13.7271C14.1795 10.18 14.4533 10.2395 14.4533 10.5967C14.4533 10.9538 14.1795 11.0134 13.7271 11.0134Z",
        fill: "black"
    })));
Rarible.displayName = 'Rarible';
export default Rarible;
